export const MuiTabs = {
  styleOverrides: {
    root: ({ theme }) => ({
      minHeight: "initial",
      color: theme.palette.text.main,
      backgroundColor: "initial",
      justifyContent: "space-between",
      margin: "auto",

      ".MuiTabs-indicator": {
        height: "1px",
      },

      ".MuiButtonBase-root": {
        padding: "16px 8px 4px",
        fontSize: "15px",
        fontWeight: "500",
        minHeight: "30px",
        minWidth: "60px",
        textTransform: "none",
        color: theme.palette.grey[100],

        "&.Mui-selected": {
          color: theme.palette.text.main,
          background:
            "linear-gradient(178.47deg,rgba(147,216,242,0) -3.96%,rgba(147,216,242,.12) 147.38%)",
        },
      },
    }),
  },
  defaultProps: {
    indicatorColor: "secondary",
    textColor: "secondary",
  },
};

export default MuiTabs;
